<div id="w3l-appointment" style="width: 800px;">
  <section class="appointment-section section-gap" >
    <div class="wrapper">


          <form action="#" method="post" >
            <div class="fields-grid" >
             
              <div class="styled-input" >
                <label style="width: 100%;text-align: center;">Patent Insurance Informations</label>
             
              </div>
              <div class="styled-input" >
              
                <label style="width: 80%;"></label>  
                 <img [hidden]= "wk_Acc_Not" src="assets/images/NoInsurance.jpg"  alt="Item Image" width="20%" height="60px" style="border: 1px;border-style: double;" />
                 <img [hidden]= "wk_Acc_Not1" src="data:image/jpg;base64,{{myimage}}"  alt="Item Image" width="20%" height="60px" style="border: 1px;border-style: double;" /> 
   
              </div>
            <!---------- ********** Patent Insurance Informations *****--------->
           <div class="appointment-form-field">
            <label style="width: 25%;">{{ 'Medical Company' | translate }}</label>
            <select id="medcompany" name="medcompany" style="width: 40%;" [(ngModel)]= "medcompany" [value]="medcompany" required="" (change)="RetriveCompany()" (selectionchange)="RetriveCompany()">
                <option value="0">None</option>
               <option value="{{doc.insid}}" *ngFor="let doc of CompamyList; let i = index">{{doc.insenglishname}}</option>
            </select>
            <label style="width: 2%;"></label>
            <label style="width: 19%;text-align: center;">{{ 'ID' | translate }}</label>
            <input type="text" name="notes" required="" [(ngModel)]= "patientid" placeholder=""style="width: 21%;background-color: white;" >
          </div>

           <div class="appointment-form-field">
            <label style="width: 26%;">{{ 'Contract for' | translate }}</label>
            <input type="text" name="contract" required="" [(ngModel)]= "contcompany" placeholder=""style="width: 41%; background-color: white;" >
            <label style="width: 2%;"></label>
            <label style="width: 20%;">{{ 'Expiration date' | translate }}</label>
            <input type="date" name="exdate" required="" [(ngModel)]= "expdate" style="width: 20%;background-color: white;" >
          </div>
               <BR>
              <BR>

          <div class="appointment-form-field">
            <label style="width: 20%;"></label>
            <label style="width: 20%;height: 100%;padding-top: 1.5%;font-weight: bold; text-align: center;background-color: orange;">{{ 'Medication %' | translate }}</label>            
            <label style="width: 2%;"></label>
            <label style="width: 20%;height: 100%;padding-top: 1.5%;font-weight: bold;text-align: center;background-color: orange;">{{ 'Out Patient %' | translate }}</label>
            <label style="width: 2%;"></label>
              <label style="width: 20%;height: 100%;padding-top: 1.5%;font-weight: bold;text-align: center;background-color: orange;">{{ 'Lab. %' | translate }}</label>
            
          </div>
          <div class="appointment-form-field">
            <label style="width: 20%;"></label>
              <input type="number" name="medperc" required="" [(ngModel)]= "medperc" style="width: 20%; background-color: white;" >
              <label style="width: 2%;"></label>
              <input type="number" name="out pa" required="" [(ngModel)]= "outpatper" style="width: 20%;background-color: white;" >
               <label style="width: 2%;"></label>
              <input type="number" name="lab" required="" [(ngModel)]= "labperc" style="width: 20%;background-color: white;" >
            </div>
 
              <BR>
              <BR>
            <div style="text-align: center; ">
                <button type="button" class="theme-button btn" name="submit" (click)="submitInsurance()" >Submit</button>
                <button type="button" class="theme-button btn" name="Delete" (click)="mesgDelete()"  >Delete</button>
                <button type="button" class="theme-button btn" name="New" (click)="CloseDialog()">Close</button>
            </div>
            <div class="clear">

            </div>
          </div>
          </form>




    </div>
  </section>
</div>


